import type { Input } from 'valibot';
import {
  boolean,
  maxLength,
  minLength,
  number,
  object,
  optional,
  string,
  nullish
} from 'valibot';

// データベースから取得される基本的なcompany_messageオブジェクト
export const companyMessageDBObject = object({
  id: string(),
  user_id: string(),
  title: string([
    minLength(1, "タイトルは必須です"),
    maxLength(200, "タイトルは200文字以内で入力してください")
  ]),
  content: string([
    minLength(1, "本文は必須です"),
    maxLength(2000, "本文は2000文字以内で入力してください")
  ]),
  author_name: string([
    minLength(1, "作成者名は必須です"),
    maxLength(100, "作成者名は100文字以内で入力してください")
  ]),
  author_position: optional(nullish(string([
    maxLength(100, "役職は100文字以内で入力してください")
  ]))),
  is_public: boolean(),
  display_order: number(),
  created_at: string(),
  updated_at: string(),
});

// 会社メッセージ作成時の入力スキーマ
export const companyMessageCreateSchema = object({
  user_id: string(),
  title: string([
    minLength(1, "タイトルは必須です"),
    maxLength(200, "タイトルは200文字以内で入力してください")
  ]),
  content: string([
    minLength(1, "本文は必須です"),
    maxLength(2000, "本文は2000文字以内で入力してください")
  ]),
  author_name: string([
    minLength(1, "作成者名は必須です"),
    maxLength(100, "作成者名は100文字以内で入力してください")
  ]),
  author_position: (optional((string([
    maxLength(100, "役職は100文字以内で入力してください")
  ])))),
  is_public: optional(boolean()),
  display_order: optional(number()),
});

// 会社メッセージ作成時のeditスキーマ
export const companyMessageEditSchema = object({
  title: string([
    minLength(1, "タイトルは必須です"),
    maxLength(200, "タイトルは200文字以内で入力してください")
  ]),
  content: string([
    minLength(1, "本文は必須です"),
    maxLength(2000, "本文は2000文字以内で入力してください")
  ]),
  author_name: string([
    minLength(1, "作成者名は必須です"),
    maxLength(100, "作成者名は100文字以内で入力してください")
  ]),
  author_position: (optional((string([
    maxLength(100, "役職は100文字以内で入力してください")
  ])))),
});

// 会社メッセージ更新時の入力スキーマ
export const companyMessageUpdateSchema = object({
  title: optional(string([
    minLength(1, "タイトルは必須です"),
    maxLength(200, "タイトルは200文字以内で入力してください")
  ])),
  content: optional(string([
    minLength(1, "本文は必須です"),
    maxLength(2000, "本文は2000文字以内で入力してください")
  ])),
  author_name: optional(string([
    minLength(1, "作成者名は必須です"),
    maxLength(100, "作成者名は100文字以内で入力してください")
  ])),
  author_position: optional(nullish(string([
    maxLength(100, "役職は100文字以内で入力してください")
  ]))),
  is_public: optional(boolean()),
  display_order: optional(number()),
});

// 公開用のcompany_messageスキーマ（公開フラグがtrueのもののみ）
export const companyMessagePublicSchema = companyMessageDBObject;

// TypeScript型定義
export type CompanyMessageDB = Input<typeof companyMessageDBObject>;
export type CompanyMessageCreate = Input<typeof companyMessageCreateSchema>;
export type CompanyMessageUpdate = Input<typeof companyMessageUpdateSchema>;
export type CompanyMessageEdit = Input<typeof companyMessageEditSchema>;
export type CompanyMessagePublic = Input<typeof companyMessagePublicSchema>;